import { STATUS_MAP } from "../constants";

function Status({ status }) {
  const statusData = STATUS_MAP[status] || {
    label: status || "-",
    color: "#212529",
    borderColor: "#212529",
    backgroundColor: "rgba(33, 37, 41, 0.08)",
  };

  return (
    <span
      className="badge border"
      style={{
        color: statusData.color,
        borderColor: statusData.borderColor,
        backgroundColor: statusData.backgroundColor,
      }}
    >
      {statusData.label}
    </span>
  );
}

export default Status;
